import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import moment from 'moment';
import React, {useContext} from 'react';
import {EForm, ESubmitButton} from 'webapp-lib/Components';
import {mixinFlexboxRow} from 'webapp-lib/styling';
import {DATE_FORMAT, TIME_FORMAT} from 'webapp-lib/utils';

import {
  EFDateInput,
  EFTimeInput,
  requiredRule,
  useForm,
} from '_/utilities/form';
import {validateNoPastTime} from '_/utilities/form/validations';

import {StoreContext} from '../store';

enum NotificationCustonDateInputFormFields {
  Date = 'date',
  Time = 'time',
}

const UNotificationCustonDateInputForm = ({
  notificationId,
}: {
  notificationId: string;
}): React.ReactElement => {
  const store = useContext(StoreContext);
  const {control, handleSubmit, disableActions, formState, trigger, getValues} =
    useForm({
      defaultValues: {
        [NotificationCustonDateInputFormFields.Date]:
          moment().format(DATE_FORMAT),
        [NotificationCustonDateInputFormFields.Time]: moment()
          .add('10', 'minutes')
          .format(TIME_FORMAT),
      },
      onSubmit: async (values) => {
        const date = moment(`${values.date}T${values.time}:00Z`).utc();

        const offset = new Date().getTimezoneOffset();
        date.add(offset, 'minutes');

        await store.setDelay({
          newDate: date.format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
          notificationId,
        });
      },
    });

  return (
    <CustonDateFormWrapper>
      <EForm onSubmit={handleSubmit}>
        <DateAndTimeWrapper>
          <EFDateInput
            control={control}
            customOnChange={(e, originalEventHandler) => {
              trigger();
              originalEventHandler(e);
            }}
            minDate={moment().format(DATE_FORMAT)}
            name={NotificationCustonDateInputFormFields.Date}
            rules={{
              ...requiredRule,
              validate: (value: string): true | string =>
                validateNoPastTime(
                  value,
                  getValues(NotificationCustonDateInputFormFields.Time)
                ),
            }}
          />
          <EFTimeInput
            control={control}
            customOnChange={(e, originalEventHandler) => {
              trigger();
              originalEventHandler(e);
            }}
            name={NotificationCustonDateInputFormFields.Time}
            rules={{
              ...requiredRule,
              validate: (value: string): true | string =>
                validateNoPastTime(
                  getValues(NotificationCustonDateInputFormFields.Date),
                  value
                ),
            }}
          />
        </DateAndTimeWrapper>
        <ESubmitButton
          disabled={disableActions}
          isSubmitting={formState.isSubmitting}
        />
      </EForm>
    </CustonDateFormWrapper>
  );
};
const DateAndTimeWrapper = styled.div`
  ${mixinFlexboxRow}
  gap: var(--form-gutter);
`;

const CustonDateFormWrapper = styled.div`
  padding: var(--gutter);
`;

export const NotificationCustonDateInputForm = observer(
  UNotificationCustonDateInputForm
);
